import React, { Component } from 'react';

import { isAfterDataFimInscricaoEDataFimPagamento } from '../../helper/ContextHelper';

import Grid from '@material-ui/core/Grid';

import Table, { DataTableLineTotals as Totals } from '../../components/Table/Table';

import { numberFormat } from '../../helper/MaskHelper';

import { 
    ButtonNewTabEscolasPorUfAndDepAdminAndStatus,
    ButtonNewTabEscolasPorUfAndStatus,
} from '../Buttons/ButtonsNewTab';

export class DadosGestaoAluno extends Component {
    sumAlunosPrevistosMirim1 = () => this.props.ufs.reduce((total, i) => total + i.qtdAlunosPrevistosMirim1, 0);
    sumAlunosPrevistosMirim2 = () => this.props.ufs.reduce((total, i) => total + i.qtdAlunosPrevistosMirim2, 0);
    sumAlunos = () => this.props.ufs.reduce((total, i) => total + i.qtdAlunosPrevistosTotal, 0);
    sumEscolasPublicas = () => this.props.ufs.reduce((total, i) => total + i.qtdEscolasPublicas, 0);
    sumEscolasPrivadasQuePagaram = () => this.props.ufs.reduce((total, i) => total + i.qtdEscolasPrivadasQuePagaram, 0);
    sumEscolasPrivadasQuePrecisamPagar = () => this.props.ufs.reduce((total, i) => total + i.qtdEscolasPrivadasQuePrecisamPagar, 0);
    sumEscolas = () => this.props.ufs.reduce((total, i) => total + i.qtdEscolasInscritasTotal, 0);

    newTabEscolasInscritasPorUfAndDepAdmin = (qtd, uf, depAdmin) => <ButtonNewTabEscolasPorUfAndDepAdminAndStatus qtd={numberFormat(qtd)} uf={uf} depAdmin={depAdmin} status="CONCLUIDA" />
    newTabEscolasPorUfAndStatus = (qtd, uf, status) => <ButtonNewTabEscolasPorUfAndStatus qtd={numberFormat(qtd)} uf={uf} status={status} />

    render() {
        const columns = [
            { label: 'UF', name: 'nmUf', func: null, key: true, width: '10', orderLabel: 'asc', },
            { label: 'Alunos Previstos - Mirim 1', name: 'qtdAlunosPrevistosMirim1', func: numberFormat, key: false, width: '12', },
            { label: 'Alunos Previstos - Mirim 2', name: 'qtdAlunosPrevistosMirim2', func: numberFormat, key: false, width: '12', },
            { label: 'Total de Alunos', name: 'qtdAlunosPrevistosTotal', func: numberFormat, key: false, width: '12', },
            { label: 'Escolas Públicas', name: 'qtdEscolasPublicas', func: (qtd, uf) => this.newTabEscolasInscritasPorUfAndDepAdmin(qtd, uf, "PUBLICA"), key: false, width: '12', },
            { label: 'Escolas Privadas', name: 'qtdEscolasPrivadasQuePagaram', func: (qtd, uf) => this.newTabEscolasInscritasPorUfAndDepAdmin(qtd, uf, "PRIVADA"), key: false, width: '12', },
            { label: 'Escolas Aguardando Pagamento', name: 'qtdEscolasPrivadasQuePrecisamPagar', func: (qtd, uf) => this.newTabEscolasPorUfAndStatus(qtd, uf, "AGUARDANDO_PAGAMENTO"), key: false, width: '12', hidden: isAfterDataFimInscricaoEDataFimPagamento(this.props.contexts), },
            { label: 'Total de Escolas Inscritas', name: 'qtdEscolasInscritasTotal', func: (qtd, uf) => this.newTabEscolasPorUfAndStatus(qtd, uf, "CONCLUIDA"), key: false, width: '12', },
        ];

        const totals = [
            { column: 0, value: "Total", width: '10', },
            { column: 1, value: numberFormat(this.sumAlunosPrevistosMirim1()), width: '12', },
            { column: 2, value: numberFormat(this.sumAlunosPrevistosMirim2()), width: '12', },
            { column: 3, value: numberFormat(this.sumAlunos()), width: '12', },
            { column: 4, value: numberFormat(this.sumEscolasPublicas()), width: '12', },
            { column: 5, value: numberFormat(this.sumEscolasPrivadasQuePagaram()), width: '12', },
            { column: 6, value: numberFormat(this.sumEscolasPrivadasQuePrecisamPagar()), width: '12', hidden: isAfterDataFimInscricaoEDataFimPagamento(this.props.contexts), },
            { column: 7, value: numberFormat(this.sumEscolas()), width: '12', },
        ];

        return (
            <Grid container spacing={3} style={{ marginTop: this.props.marginTop ?? 8 }}>
                <Grid item xs={12}>
                    <Table
                        columns={columns}
                        tableData={this.props.ufs}
                        actions={[]}
                        page={null}
                        rowsPerPage={null}
                        sort={null}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Totals lineData={totals} columns={columns} />
                </Grid>
            </Grid>
        )
    }
}

export default DadosGestaoAluno;